export default "assets/images/map_us-2b754099.svg";